<template>
	<div class="formGroup withIcon">
		<label class="textGrey" for="dateRangePicker">{{ label }}</label>
		<vue-date-picker
			ref="dp"
			v-model="dates"
			range
			:placeholder="label"
			:hide-input-icon="true"
			class="group"
			:clearable="false"
			:enable-time-picker="false"
			format="dd/MM/yyyy"
			:text-input="true"
			:auto-apply="true"
			:input-class-name="'date-input'"
			@update:model-value="handleDateChange"
		>
			<template #action-buttons>
				<div class="flex w-full flex-row justify-between gap-1">
					<button
						class="rounded-sm bg-red-500 px-3 py-1 font-sans text-[13px] capitalize transition-colors hover:bg-red-600"
						style="color: white"
						@click="closeMenu"
					>
						CANCEL
					</button>
					<button
						class="rounded-sm bg-blue-500 px-3 py-1 font-sans text-[13px] capitalize transition-colors hover:bg-blue-600"
						style="color: white"
						@click="selectDate"
					>
						SELECT
					</button>
				</div>
			</template>
		</vue-date-picker>
		<span class="fa-light fa-calendar" :class="dates && dates.length ? 'pr-6' : 'pr-0'"></span>
		<span
			v-if="dates && dates.length"
			class="fa-light fa-close textRed fontHeavy pointer-events-auto"
			style="z-index: 2; right: 12px"
			@click="clearDates"
		></span>
	</div>
</template>

<script>
export default {
	props: {
		modelValue: {
			type: Array,
			default: () => []
		},
		label: {
			type: String,
			default: ''
		},
		maxRange: {
			type: Number,
			default: 730 // Default to 2 years
		}
	},
	emits: ['update:modelValue', 'clear-dates'],
	computed: {
		dates: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		}
	},
	methods: {
		selectDate() {
			this.$refs.dp.selectDate()
		},
		closeMenu() {
			this.$refs.dp.closeMenu()
		},
		clearDates() {
			this.$emit('update:modelValue', [])
			this.$emit('clear-dates')
		},
		handleDateChange(dates) {
			if (dates && dates.length === 2) {
				const startDate = new Date(dates[0])
				const endDate = new Date(dates[1])
				const diffTime = Math.abs(endDate - startDate)
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

				if (diffDays > this.maxRange) {
					const newEndDate = new Date(startDate)
					newEndDate.setDate(startDate.getDate() + this.maxRange)
					this.$emit('update:modelValue', [startDate, newEndDate])
				}
			}
		}
	}
}
</script>

<style>
.date-input {
	width: 100%;
}

@media (max-width: 640px) {
	.date-input {
		font-size: 14px;
	}
}
</style>
